import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMedReview from '../reducers/med-review.reducer';
import { QueryResultsModel } from '../../../../core/_base/crud';
import { DeviceModel } from '../../../../core/me/_models/Device.model';
import { each } from 'lodash-es';

export const selectMedReviewState = createFeatureSelector<fromMedReview.State>(
  fromMedReview.medReviewFeatureKey,
);

export const selectMedReviewLoading = createSelector(
  selectMedReviewState,
  (patientsState) => patientsState.loading,
);

export const selectMedReviewInitWaitingMessage = createSelector(
  selectMedReviewState,
  (patientsState) => patientsState.showInitWaitingMessage,
);

export const selectMedReview = createSelector(selectMedReviewState, (deviceState) => {
  const items: DeviceModel[] = [];
  each(deviceState.ids, (ele) => {
    const index: number = +ele;
    items.push(deviceState.entities[index]);
  });
  return new QueryResultsModel(items, deviceState.totalCount);
});

export const selectBamboohealthData = createSelector(
  selectMedReviewState,
  (state) => state.bambooHealthData,
);
